import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
`;

export const Description = styled.p`
  margin: 0;
  color: #5c5c5c;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  max-width: 100%;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;
